import {
    GET_LIST_TREATMENT_SESSION,
    GET_TREATMENT_SESSION_BY_CUSTOMER,
    GET_SPECIFIC_TREATMENT_SESSION,
    REMOVE_TREATMENT_SESSION
} from '../actions/types';

/**
 * initial state cho module TreatmentSession
 */
const INIT_STATE = {

    treatmentSessionList: {
        list: [],
        pagination: {
            currentPage: 1,
            total: 0,
            perPage: 30
        }
    },
    treatmentSessionCustomer: {
        list: [],
        pagination: {
            currentPage: 1,
            total: 0,
            perPage: 30
        }
    },
    currentTreatmentSession: null,

};

export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case GET_LIST_TREATMENT_SESSION: {
            const payload = action.payload.data?.list || {};
            const stats = action.payload.data?.stats || {};

            return {
                ...state,
                treatmentSessionList: {
                    list: payload.data || [],
                    pagination: {
                        currentPage: parseInt(payload.current_page || 1),
                        total: parseInt(payload.total || 0),
                        perPage: parseInt(payload.per_page || 30),
                    },
                    statistics: stats
                }
            };
        }

        case GET_TREATMENT_SESSION_BY_CUSTOMER: {
            const payload = action.payload || {};

            return {
                ...state,
                treatmentSessionCustomer: {
                    list: payload.data || [],
                    pagination: {
                        currentPage: parseInt(payload.current_page || 1),
                        total: parseInt(payload.total || 0),
                        perPage: parseInt(payload.per_page || 30),
                    }
                }
            };
        }

        case GET_SPECIFIC_TREATMENT_SESSION: {
            return {
                ...state,
                currentTreatmentSession: action.payload || null
            };
        }

        case REMOVE_TREATMENT_SESSION: {
            const removedIds = action.payload || [];

            return {
                ...state,
                treatmentSessionList: {
                    ...state.treatmentSessionList,
                    list: state.treatmentSessionList.list.filter(
                        item => !removedIds.includes(item.id)
                    )
                }
            };
        }

        default:
            return state;
    }
};
